import { isPlaceholderAvatarUrl, resolveAvatarImageUrl } from './avatarInitials';

function avatarFromUserRecord(user) {
  if (!user || typeof user !== 'object') {
    return { image: null, thumbnail: null };
  }

  let image = user.avatar_url || null;

  if (!image && typeof user.avatar === 'string') {
    image = user.avatar;
  }

  if (!image && user.avatar && typeof user.avatar === 'object') {
    image = user.avatar.path_string || user.avatar.url || user.avatar.thumb || null;
  }

  return {
    image,
    thumbnail: user.thumbnail || null,
  };
}

/**
 * Ảnh đại diện cho một notification (list / popover).
 * @param {{ image?: string|null, data?: unknown }} notification
 * @returns {string|null}
 */
export function notificationAvatarUrl(notification) {
  if (!notification || typeof notification !== 'object') {
    return null;
  }

  let image = null;
  let thumbnail = null;

  if (notification.image && typeof notification.image !== 'object' && !isPlaceholderAvatarUrl(notification.image)) {
    image = notification.image;
  }

  let data = notification.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = null;
    }
  }

  if (data && typeof data === 'object') {
    const user = data.user;
    const fromUser = avatarFromUserRecord(user);
    if (!image) image = fromUser.image;
    if (!thumbnail) thumbnail = fromUser.thumbnail;
  }

  return resolveAvatarImageUrl({ image, thumbnail, size: 'small' });
}

/**
 * Tên hiển thị avatar chữ cho notification.
 * @param {{ data?: unknown }} notification
 * @returns {string}
 */
export function notificationAvatarName(notification) {
  let data = notification?.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return '';
    }
  }

  const user = data?.user;
  if (!user) return '';

  return String(user.name || user.fullname || user.username || '').trim();
}

/**
 * Ảnh nhóm chat cho popup tin nhắn mới.
 * @param {Record<string, unknown>|null|undefined} group
 * @returns {string|null}
 */
export function chatGroupAvatarUrl(group) {
  if (!group || typeof group !== 'object') {
    return null;
  }

  return resolveAvatarImageUrl({
    image: group.avatar_url || group.avatar || null,
    thumbnail: group.thumbnail,
    size: 'small',
  });
}
